module.exports = __webpack_public_path__ + "media/images/equipments-bg-02-2701389e672cc38df17558fc4a92b97b.png";